import { QueryFunctionContext, useQuery } from "@tanstack/react-query";
import { configuration } from "../../../configuration";
import { FetchError, GetTeamDto } from "../../types";
import { useAccessToken } from "../../use-access-token";
import { queryKeys } from "../queryKeys";

const useGetTeamRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function getTeamRequest({
    queryKey,
  }: QueryFunctionContext<ReturnType<typeof queryKeys.teams.getTeam>>): Promise<GetTeamDto> {
    const accessToken = await getAccessToken();
    const [{ slug, userId }] = queryKey;
    const url = new URL(`${configuration.apiRootUrl}/teams/${slug}`);

    if (userId) {
      url.searchParams.set("userId", userId);
    }

    const response = await fetch(url.href, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      throw new FetchError(response);
    }

    return response.json();
  }

  return { getTeamRequest };
};

const useGetTeam = (slug: string | undefined, userId?: string, enabled: boolean = true) => {
  const { getTeamRequest } = useGetTeamRequest();

  return useQuery({
    queryKey: queryKeys.teams.getTeam(slug, userId),
    queryFn: getTeamRequest,
    enabled: slug !== undefined && enabled,
  });
};

export { useGetTeam };
